import * as React from 'react';
import { TextField } from 'mui-rff';
import * as Yup from 'yup';
import { FormPage } from '../../../components/FormPage';
import { FormSection } from '../../../components/FormSection';
import { BokunTermAgreements } from '../../../components/BokunTermAgreements';

const validationSchema = Yup.object().shape({
    businessName: Yup.string().required('Business name is required'),
    businessEmail: Yup.string().email('Business email is invalid'),
    supportEmail: Yup.string().email('Support email is invalid'),
    emergencyDeveloperEmail: Yup.string().email('Emergency developer email is invalid'),
    termsApiAgreed: Yup.bool().oneOf([true], 'You must agree to our Bókun API Terms'),
    termsPartnerAgreed: Yup.bool().oneOf([true], 'You must agree to our Bókun Partner terms'),
});

export const OrganizationForm: React.FC<{
    organization: any;
    loading?: boolean;
    onSubmit: any;
    error: any;
}> = ({ organization, loading, onSubmit }) => {
    return (
        <FormPage
            title="Account settings"
            loading={loading}
            initialValues={organization}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            render={() => (
                <React.Fragment>
                    <FormSection title="Business Info">
                        <TextField
                            type="text"
                            required
                            fullWidth
                            id="businessName"
                            label="Business name"
                            helperText="This will appear alongside your app listing."
                            name="businessName"
                            margin="normal"
                            autoFocus
                        />
                        <TextField
                            type="text"
                            fullWidth
                            id="websiteUrl"
                            label="Website"
                            name="websiteUrl"
                            margin="normal"
                        />
                    </FormSection>

                    <FormSection title="Contact Info">
                        <TextField
                            type="email"
                            fullWidth
                            id="businessEmail"
                            label="Business email"
                            helperText="The email where all general account info will be sent."
                            name="businessEmail"
                            margin="normal"
                        />
                        <TextField
                            type="email"
                            fullWidth
                            id="supportEmail"
                            label="Support email"
                            helperText="The email where all support info will be sent."
                            name="supportEmail"
                            margin="normal"
                        />
                        <TextField
                            type="text"
                            fullWidth
                            id="phoneNumber"
                            label="Phone number"
                            helperText="We promise to call only if it is important."
                            name="phoneNumber"
                            margin="normal"
                        />
                    </FormSection>

                    <FormSection
                        title="Emergency Dev Contact"
                        description="Sometimes we need to communicate critical technical information to developers who maintain your Bokun apps."
                    >
                        <TextField
                            type="email"
                            fullWidth
                            id="emergencyDeveloperEmail"
                            label="Emergency developer email"
                            helperText="The email where all API breaking changes and app operational info will be sent."
                            name="emergencyDeveloperEmail"
                            margin="normal"
                        />
                        <TextField
                            type="text"
                            fullWidth
                            id="emergencyDeveloperPhoneNumber"
                            label="Emergency developer phone number"
                            helperText="The phone number that can be used to notify of emergency API breaking changes and operational issues."
                            name="emergencyDeveloperPhoneNumber"
                            margin="normal"
                        />
                    </FormSection>

                    <FormSection
                        title="Term agreements"
                        description="You must accept the terms for your organization before being able to publish your apps."
                    >
                        <BokunTermAgreements />
                    </FormSection>
                </React.Fragment>
            )}
        />
    );
};
